import { forwardRef } from 'react';
import { Disableable, Sized } from '@optimus-web/common';
import { Field } from '../Field';
import { TextareaContainerElement, TextAreaPlaceholder, TextareaStyledComponent, ValueContainerElement } from './style';

export interface TextareaProps extends Sized, Disableable {
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>, value?: string) => void;
    onHeightChange?: (height: string) => void;
    placeholder?: React.ReactNode;
    rows?: number;
    children?: React.ReactNode;
    form?: string;
    label?: React.ReactNode;
    value?: string;
    name: string;
    id?: string;
    required?: boolean;
    error?: React.ReactNode;
}

export const TextareaElement = forwardRef(
    (
        {
            name,
            id,
            value = '',
            placeholder,
            children,
            rows = 3,
            onChange,
            size,
            disabled,
            required,
            error,
            ...other
        }: TextareaProps,
        ref: React.Ref<HTMLTextAreaElement>
    ) => {
        const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
            if (onChange) {
                onChange(event, event.target.value);
            }
        };

        const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
            event.stopPropagation();
        };

        const textareaProps = {
            ...other,
            ref,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            value,
            rows,
            inputSize: size,
            disabled,
            id: name,
            required,
            error,
            name,
        };

        return (
            <TextareaContainerElement>
                <ValueContainerElement>
                    {!value && (
                        <TextAreaPlaceholder inputSize={size} disabled={disabled}>
                            {placeholder}
                        </TextAreaPlaceholder>
                    )}
                    <TextareaStyledComponent aria-invalid={error != null} {...textareaProps} />
                    {children}
                </ValueContainerElement>
            </TextareaContainerElement>
        );
    }
);

const Textarea = Field(TextareaElement);

export default Textarea;
